import React, { useEffect } from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import { ASSETS_BASE_URL } from "constants";

const Success = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <main className="main section container full-page">
      <div className="content-wrapper">
        <img
          src={`${ASSETS_BASE_URL}assets/images/rize/email/expired.svg`}
          alt="Expired"
          className="success-img"
        />

        <p className="email-title">
          Uh-oh! This link has expired or is invalid.
        </p>

        <h5 className="email-subtitle">
          It seems this verification link isn’t working anymore. No worries - just open the MY alrajhi app and request a fresh one.
        </h5>
      </div>
    </main>
  );
};

export default Success;
